import { Delete } from '@mui/icons-material';
import { SxProps, Theme, Typography } from '@mui/material';
import { Control, Path, UseFormSetValue } from 'react-hook-form';

import { TextFormField } from 'components/FormFields';
import {
  PropertyCardEditProps,
  PropertyCardItemProps,
} from 'components/PropertiesCard/PropertiesCard';
import { GenerateFieldType } from 'hooks/forms/useFieldGenerator';

export const EXTERNAL_IDS_FIELD = 'externalIds';

export const buildExternalIdsEditableProperties = <T extends Record<string, unknown>>({
  keys,
  control,
  generateField,
  setValue,
  editingKey,
  isAdding,
  localOnlyKeys,
  localEntrySx,
  fieldPrefix = EXTERNAL_IDS_FIELD as Path<T>,
}: {
  keys: Array<string>;
  control: Control<T>;
  generateField: GenerateFieldType<T>;
  setValue: UseFormSetValue<T>;
  editingKey: Path<T> | null;
  isAdding: boolean;
  localOnlyKeys: Set<string>;
  localEntrySx: SxProps<Theme>;
  fieldPrefix?: Path<T>;
}): Array<PropertyCardItemProps & PropertyCardEditProps> =>
  keys.map(key => {
    const fieldName = `${String(fieldPrefix)}.${key}` as Path<T>;
    const fieldProps = generateField(fieldName);
    const isLocal = localOnlyKeys.has(key);

    return {
      name: key,
      ...fieldProps,
      value: isLocal ? (
        <Typography component="span" color="primary.main" fontWeight={500}>
          {fieldProps.value}
        </Typography>
      ) : (
        fieldProps.value
      ),
      sx: isLocal ? localEntrySx : undefined,
      editComponent: (
        <TextFormField control={control} name={fieldName as never} label={key} />
      ),
      actions: [
        ...(fieldProps.actions || []),
        {
          disabled: Boolean(editingKey) || isAdding,
          onClick: () => {
            setValue(fieldName, '' as never, { shouldDirty: true, shouldValidate: true });
          },
          icon: <Delete />,
        },
      ],
    };
  });
